<template>
  <section class="ctn">
    <header class="header left">
      <router-link class="paper-action" :to="{ path: '/servers' }"><heim-icon icon="arrow-back"></heim-icon><span>{{ $t('back') }}</span></router-link>
    </header>
    <heim-card>
      <header class="header left">
        <h1>{{ $t('new') }} {{ $t('server') }}</h1>
      </header>
      <main>
        <form @submit.prevent="handleForm">
          <div class="row">
            <span class="label">{{ $t('server') }}</span>
            <div class="inputs">
              <heim-input :label="$t('name') + ' *'" name="name" placeholder="e.g : Server 1" v-model="name" v-validate="'required'"></heim-input>
              <span class="help is-danger" v-show="errors.has('name')"><heim-icon class="icon" icon="error"></heim-icon> {{ errors.first('name') }}</span>

              <heim-input :label="$t('ip') + ' *'" name="ip" placeholder="0.0.0.0" v-model="ip" v-validate="'required|ip'"></heim-input>
              <span class="help is-danger" v-show="errors.has('ip')"><heim-icon class="icon" icon="error"></heim-icon> {{ errors.first('ip') }}</span>

              <heim-textarea :label="$t('description') + ' *'" name="description" :placeholder="$t('serverDescription')" v-model="description" v-validate="'required'"></heim-textarea>
              <span class="help is-danger" v-show="errors.has('description')"><heim-icon class="icon" icon="error"></heim-icon> {{ errors.first('description') }}</span>
            </div>
          </div>
          <div class="row">
            <span class="label">{{ $t('cpu') }}</span>
            <div class="inputs">
              <heim-input :label="$t('cpuThreshold')  + ' *'" name="cpu_threshold" placeholder="90" v-model="cpu_threshold" v-validate="'required'"></heim-input>
              <span class="help is-danger" v-show="errors.has('cpu_threshold')"><heim-icon class="icon" icon="error"></heim-icon> {{ errors.first('cpu_threshold') }}</span>
              
              <div class="toggle-box"><span class="label">{{ $t('isEnabled') }}</span><heim-toggle-button name="cpu_alert" v-model="cpu_alert"></heim-toggle-button></div>
            </div>
          </div>
          <div class="row">
            <span class="label">{{ $t('memory') }}</span>
            <div class="inputs">
              <heim-input :label="$t('memoryThreshold')  + ' *'" name="mem_threshold" placeholder="90" v-model="mem_threshold" v-validate="'required'"></heim-input>
              <span class="help is-danger" v-show="errors.has('mem_threshold')"><heim-icon class="icon" icon="error"></heim-icon> {{ errors.first('mem_threshold') }}</span>
              
              <div class="toggle-box"><span class="label">{{ $t('isEnabled') }}</span><heim-toggle-button name="mem_alert" v-model="mem_alert"></heim-toggle-button></div>
            </div>
          </div>
          <div class="row">
            <span class="label">{{ $t('drive') }}</span>
            <div class="inputs">
              <heim-input :label="$t('diskThreshold')  + ' *'" name="drive_threshold" placeholder="90" v-model="drive_threshold" v-validate="'required'"></heim-input>
              <span class="help is-danger" v-show="errors.has('drive_threshold')"><heim-icon class="icon" icon="error"></heim-icon> {{ errors.first('drive_threshold') }}</span>
              
              <div class="toggle-box"><span class="label">{{ $t('isEnabled') }}</span><heim-toggle-button name="drive_alert" v-model="drive_alert"></heim-toggle-button></div>
            </div>
          </div>
          <div class="row">
            <span class="label">{{ $t('monitoring') }}</span>
            <div class="inputs">
              <heim-input
                :label="$t('pingInterval') + ' (ms)*'"
                name="interval"
                type="number"
                placeholder="300000"
                v-model="interval"
                v-validate="'required'"
              ></heim-input>
              <span class="help is-danger" v-show="errors.has('interval')"><heim-icon class="icon" icon="error"></heim-icon> {{ errors.first('interval') }}</span>
              
              <heim-input
                :label=" $t('errorRecurrence')"
                name="nb_occurence"
                type="number"
                placeholder="2"
                v-model="nb_occurence"
                v-validate="'required'"
              ></heim-input>
              <span class="help is-danger" v-show="errors.has('nb_occurence')"><heim-icon class="icon" icon="error"></heim-icon> {{ errors.first('nb_occurence') }}</span>
            </div>
          </div>
          <div class="row">
            <span class="label">{{ $t('provider')  + ' *' }}</span>
            <div class="inputs">
              <heim-select
                :data="providers"
                label-key="name"
                value-key="id"
                v-model="provider_id"
                required="required"
              ></heim-select>
            </div>
          </div>
          <div class="row">
            <span class="label">{{ $t('hosting') }}</span>
            <div class="inputs">
              <heim-input :label="$t('costServer') + ' (€)'" name="cost_server" type="number" v-model="cost_server" step="0.01"></heim-input>
              <heim-input :label="$t('costHardDisk') + ' (€)'" name="cost_hard_disk" type="number" v-model="cost_hard_disk" step="0.01"></heim-input>
              <heim-input :label="$t('auxiliaryCost') + ' (€)'" name="auxiliary_cost" type="number" v-model="auxiliary_cost" step="0.01"></heim-input>
              <heim-input :label="$t('rds') + ' (€)'" type="number" v-model="rds" step="0.01"></heim-input>
              <heim-input :label="$t('backup') + ' (€)'" name="backup" type="number" v-model="backup" step="0.01"></heim-input>
              <heim-input :label="$t('bandwidth') + ' (€)'" type="number" v-model="bandwidth" step="0.01"></heim-input>
              <heim-input :label="$t('support') + ' (€)'" name="support" type="number" v-model="support" step="0.01"></heim-input>
              <heim-input :label="$t('ipElastic')" name="ip_elastic" type="text" v-model="ip_elastic"></heim-input>
              <heim-input :label="$t('typeServer')" name="type_server" v-model="type_server"></heim-input>
              <heim-input :label="$t('nbCPU')" name="nb_cpu" type="number" v-model="nb_cpu"></heim-input>
              <heim-input :label="$t('nbRAM')" name="nb_ram" type="number" v-model="nb_ram"></heim-input>
              <heim-input :label="$t('diskSpace') + $t('go_')" name="disk_space" v-model="disk_space"></heim-input>
              <div class="toggle-box">
                 <span class="label">{{ $t('reservedInstance') }}</span>
                 <heim-toggle-button uid="hosting_reserved" name="hosting_reserved" v-model="hosting_reserved"></heim-toggle-button>
              </div>
              <div class="heim-input">
                <span class="label">{{ $t('birthday') }}</span>
                <datepicker 
                type="date"
                name="hosting_birthday"
                input-class="paper-input"
                wrapper-class="date-input"
                v-model="hosting_birthday"
                placeholder="Select Date"
                ></datepicker>
              </div>
              <div class="heim-input">
                <span class="label">{{ $t('localization') }}</span>
                <places
                  class="paper-input"
                  name="hosting_localization"
                  v-model="hosting_localization"
                  placeholder="Localization"
                  @change="val => { form.country.data = val }"
                  >
                </places>
              </div>
            </div>
          </div>
          <footer>
            <heim-button :disabled="errors.any()" type="submit">{{ $t('save') }}</heim-button>
          </footer>
        </form>
      </main>
    </heim-card>
  </section>
</template>

<script>
import HeimInput from "@/components/form/input/text/heim-input.vue";
import HeimTextarea from "@/components/form/input/text/heim-textarea.vue";
import HeimToggleButton from "@/components/form/input/toggle/heim-toggle-button.vue";
import HeimSelect from "@/components/form/input/select/heim-select.vue";
import HeimButton from "@/components/form/button/heim-button.vue";
import HeimCard from "@/components/layout/card/heim-card.vue";
import HeimIcon from "@/components/icon/heim-icon.vue";
import Datepicker from "vuejs-datepicker";
import Places from "vue-places";

import { mapState } from "vuex";
export default {
  name: "ServersNew",
  components: {
    HeimInput,
    HeimTextarea,
    HeimToggleButton,
    HeimSelect,
    HeimButton,
    HeimCard,
    HeimIcon,
    Datepicker,
    Places
  },
  mounted() {
    this.$store.dispatch("getProviders");
    this.$store.dispatch("setTitle", "Create server");
  },
  data() {
    return {
      name: "",
      ip: "",
      description: "",
      cpu_threshold: "90",
      cpu_alert: false,
      mem_threshold: "90",
      mem_alert: false,
      drive_threshold: "90",
      drive_alert: true,
      interval: "300000",
      nb_occurence: "2",
      provider_id: "",
      cost_server: "",
      cost_hard_disk: "",
      auxiliary_cost: "",
      type_server: "",
      nb_cpu: "",
      nb_ram: "",
      disk_space: "",
      hosting_reserved: "",
      hosting_birthday: "",
      hosting_localization: "",
      rds: "",
      backup: "",
      bandwidth: "",
      support: "",
      ip_elastic: "",
      form: {
        country: {
          label: null,
          data: {}
        }
      }
    };
  },
  computed: {
    ...mapState({ providers: state => state.serversState.providers })
  },
  methods: {
    async handleForm() {
      const data = await this.$store.dispatch("createServer", {
        name: this.name,
        ip: this.ip,
        description: this.description,
        cpu_threshold: this.cpu_threshold,
        cpu_alert: this.cpu_alert,
        mem_threshold: this.mem_threshold,
        mem_alert: this.mem_alert,
        drive_threshold: this.drive_threshold,
        drive_alert: this.drive_alert,
        interval: this.interval,
        nb_occurence: this.nb_occurence,
        provider_id: this.provider_id,
        cost_server: this.cost_server,
        cost_hard_disk: this.cost_hard_disk,
        auxiliary_cost: this.auxiliary_cost,
        type_server: this.type_server,
        nb_cpu: this.nb_cpu,
        nb_ram: this.nb_ram,
        disk_space: this.disk_space,
        hosting_reserved: this.hosting_reserved,
        hosting_birthday: this.hosting_birthday,
        hosting_localization: this.hosting_localization,
        rds: this.rds,
        backup: this.backup,
        bandwidth: this.bandwidth,
        support: this.support,
        ip_elastic: this.ip_elastic
      });

      this.$validator.validateAll().then(result => {
        if (result && data) {
          this.$store.dispatch("setToastMessage", {
            message: "newServercreated"
          });
          this.$store.dispatch("setToastMode", {});
          this.$store.dispatch("setOpenToast", { opened: true });
          this.$router.push({ path: `/servers/${data.id}/details` });
        }
      });
    }
  }
};
</script>

<style>
input.paper-input,
.ap-input {
  background: var(--heim-grey-color);
  width: 100%;
  display: block;
  padding: 0.3em 0.4em;
  font-size: 0.9em;
  border-radius: 3px;
  border: solid 1px #ededed;
  outline: none;
  transition: box-shadow 0.3s var(--heim-transition);
}

input.paper-input:hover,
input.paper-input:focus {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
.heim-input[icon] input.paper-input {
  padding-right: 32px;
}

.date-input {
  margin-bottom: 20px;
}

.heim-input {
  max-width: 32em;
}

.heim-input input {
  width: 100%;
}

.search-location {
  display: block;
  margin: 0 auto;
  margin-top: 5vw;
  font-size: 20px;
  font-weight: 400;
  outline: none;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 10px;
}
</style>

<style scoped>
.toggle-box {
  font-size: 0.8em;
  color: rgba(0, 0, 0, 0.65);
  font-weight: 500;
  display: flex;
  align-items: center;
}
.toggle-box .label {
  display: inline-block;
  margin-bottom: 0.6em;
}

.heim-input .label {
  display: inline-block;
  font-size: 0.8em;
  color: rgba(0, 0, 0, 0.65);
  margin-bottom: 0.1em;
  font-weight: 500;
}

.ap-input {
  background: var(--heim-grey-color);
  width: 100%;
  display: block;
  padding: 0.3em 0.4em;
  font-size: 0.9em;
  border-radius: 3px;
  border: solid 1px #ededed;
  outline: none;
  transition: box-shadow 0.3s var(--heim-transition);
}
</style>
